import { render, staticRenderFns } from "./ManualNewOrEdit.vue?vue&type=template&id=04aa175d&scoped=true&"
import script from "./ManualNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./ManualNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ManualNewOrEdit.vue?vue&type=style&index=0&id=04aa175d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa175d",
  null
  
)

export default component.exports